import React from 'react';
import { AnnouncementBanner } from '../components/AnnouncementBanner';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { BonusSection } from '../components/BonusSection';
import { ForYouSection } from '../components/ForYouSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { LegalFooter } from '../components/LegalFooter';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-beige-sand font-body text-text-body overflow-x-hidden" data-id="element-286">
      <AnnouncementBanner data-id="element-287" />
      <HeroSection data-id="element-288" />
      <ProblemSection data-id="element-289" />
      <SolutionSection data-id="element-290" />
      <ForYouSection data-id="element-291" />
      <ContentSection data-id="element-292" />
      <BonusSection data-id="element-293" />
      <TestimonialsSection data-id="element-294" />
      <OfferSection data-id="element-295" />
      <FinalCTASection data-id="element-296" />
      <FAQSection data-id="element-297" />
      <LegalFooter data-id="element-298" />
      <PurchasePopup data-id="element-299" />
    </main>;
}